import React, { useState } from "react";
import { ViewMode, Gantt } from "gantt-task-react";
import { ViewSwitcher } from "./ViewSwitcher";
// import {
//   getStartEndDateForProject,
//   initTasks,
// } from "../../../../utils/constants";
// import { ViewSwitcher } from "./components/view-switcher";
// import { getStartEndDateForProject, initTasks } from "./helper";
import { format } from "date-fns";
import {
  Box,
  Button,
  Grid2,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import CommonButton from "../../../../component/Button";
import AddEditMilestone from "./AddEditMilestone";
import dayjs from "dayjs";
import { AutoAwesome, Delete, Edit } from "@mui/icons-material";
import BoxEditIco from "../../../../assets/icons/BoxEditIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import SnackBar from "../../../../component/SnackBar";
import { StyledFlexRowView } from "../../../common-components/StyledComponents";
import CommonTextField from "../../../../component/Input";
import Haley from "../../../../assets/images/Haley.png";

function initTasks() {
  const tasks = [
    {
      start: new Date(2025, 1, 1), // Feb 1, 2025
      end: new Date(2025, 3, 29), // Apr 30, 2025 (Fixed)
      name: "Market Research",
      id: 1,
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2025, 4, 1), // May 1, 2025
      end: new Date(2025, 6, 30), // Jul 31, 2025 (Fixed)
      name: "Specifications",
      id: 2,
      dependencies: ["Task 0"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2025, 7, 1), // Aug 1, 2025
      end: new Date(2025, 9, 30), // Oct 31, 2025 (Fixed)
      name: "Planning",
      id: 3,
      dependencies: ["Task 1"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2025, 10, 1), // Nov 1, 2025
      end: new Date(2026, 0, 30), // Jan 31, 2026 (Fixed)
      name: "Design",
      id: 4,
      dependencies: ["Task 2"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2026, 1, 1), // Feb 1, 2026
      end: new Date(2026, 3, 29), // Apr 30, 2026 (Fixed)
      name: "Development",
      id: 5,
      dependencies: ["Task 3"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2026, 4, 1), // May 1, 2026
      end: new Date(2026, 6, 30), // Jul 31, 2026 (Fixed)
      name: "Training",
      id: 6,
      dependencies: ["Task 4"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2026, 7, 1), // Aug 1, 2026
      end: new Date(2026, 9, 30), // Oct 31, 2026 (Fixed)
      name: "Assessment",
      id: 7,
      dependencies: ["Task 5"],
      type: "task",
      project: "ProjectSample",
    },
    {
      start: new Date(2026, 10, 1), // Nov 1, 2026
      end: new Date(2027, 0, 30), // Jan 31, 2027 (Fixed)
      name: "Documentation",
      id: 8,
      dependencies: ["Task 6"],
      type: "task",
      project: "ProjectSample",
    },
  ];
  return tasks;
}

const TaskContent = ({ task }) => {
  const formatDate = (date) => {
    const options = { month: "short", day: "2-digit", year: "numeric" };
    return new Date(date)
      .toLocaleDateString("en-US", options)
      .replace(/(\w{3}) (\d{2}), (\d{4})/, "$1.$2.$3");
  };

  return (
    <div>
      <strong>{task.title}</strong>
      <div>
        {formatDate(task.start)} - {formatDate(task.end)}
      </div>
    </div>
  );
};

const formatDate = (date) => {
  const options = { month: "short", day: "2-digit", year: "numeric" };
  return date
    .toLocaleDateString("en-US", options)
    .replace(/(\w{3}) (\d{2}), (\d{4})/, "$1.$2.$3");
};

const ProposalGanttChart = ({ isEdit, handleClickVerify }) => {
  const [view, setView] = React.useState(ViewMode.Month);
  const [tasks, setTasks] = React.useState(
    initTasks().map((task) => ({
      ...task,
      start: new Date(task.start), // Ensure it's a Date object
      end: new Date(task.end),
      displayStart: formatDate(new Date(task.start)), // Apply formatDate
      displayEnd: formatDate(new Date(task.end)),
      displayName: task.name,
    }))
  );
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [isChecked, setIsChecked] = React.useState(true);
  let columnWidth = 200; // Adjust width to fit months properly

  console.log(tasks, "tasks");

  const formattedTasks = tasks?.length
    ? tasks.map((task) => ({
        ...task,
        start: new Date(task.start), // Ensure correct date format
        end: new Date(task.end),
        displayStart: format(new Date(task.start), "MMM.dd.yyyy"), // Format for UI
        displayEnd: format(new Date(task.end), "MMM.dd.yyyy"),
      }))
    : [];

  console.log("Formatted Tasks:", formattedTasks); // Debugging

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newTask, setNewTask] = useState({
    title: "",
    from: null,
    to: null,
  });
  const [editingTask, setEditingTask] = useState(null);
  const [isEdited, setIsEdited] = useState(false);

  const handleOpenModal = (task = null) => {
    console.log(task, "task received");
    if (task?.id) {
      setIsEdited(true);
      setNewTask({
        id: task.id,
        title: task.name,
        from: task.start ? format(new Date(task.start), "yyyy-MM-dd") : "",
        to: task.end ? format(new Date(task.end), "yyyy-MM-dd") : "",
      });
    } else {
      setIsEdited(false);
      setNewTask({
        title: "",
        from: "",
        to: "",
      });
    }
    setEditingTask(task);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingTask(null);
    setIsEdited(false);
  };

  const handleInputChange = (name, value) => {
    const newValue = name === "from" || name === "to" ? dayjs(value) : value;

    setNewTask((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleAddTask = () => {
    if (!newTask.title || !newTask.from || !newTask.to) {
      // alert("Please fill all fields!");
      setSnackbarState({
        open: true,
        message: "Please fill all fields!",
        severity: "error",
      });

      return;
    }

    const newTaskEntry = {
      id: isEdited ? editingTask.id : tasks.length + 1,
      name: newTask.title,
      start: new Date(newTask.from),
      end: new Date(newTask.to),
      displayStart: formatDate(new Date(newTask.from)),
      displayEnd: formatDate(new Date(newTask.to)),
      displayName: newTask.title,
    };

    setTasks((prevTasks) =>
      isEdited
        ? prevTasks.map((t) => (t.id === editingTask.id ? newTaskEntry : t))
        : [...prevTasks, newTaskEntry]
    );
    // setTasks((prevTasks) => [...prevTasks, newTaskEntry]);

    handleCloseModal();
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleDelete = (taskId) => {
    setTasks(
      (prevTasks) => prevTasks.filter((task) => task.id !== taskId) || []
    );
  };

  return (
    <div>
      {/* <ViewSwitcher
        onViewModeChange={(viewMode) => setView(viewMode)}
        onViewListChange={setIsChecked}
        isChecked={isChecked}
      /> */}

      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <StyledSpaceBetweenBox>
            <StyledFlexRowView style={{ gap: "30px" }}>
              <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                {"Project Timeline"}
              </Typography>
              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="700"
                value="Mark as verified"
                padding="8px 15px"
                onClick={handleClickVerify}
              />
            </StyledFlexRowView>
            <StyledFlexRowView>
              {isEdit ? (
                <CommonButton
                  value={"Add New"}
                  variant="outlined"
                  color="#344054"
                  padding="8px 15px"
                  fontWeight={"700"}
                  fontSize={"15px"}
                  border={"#D0D5DD"}
                  onClick={handleOpenModal}
                />
              ) : null}
            </StyledFlexRowView>
          </StyledSpaceBetweenBox>
        </Grid2>
        <Grid2 size={12}>
          {tasks.length !== 0 && (
            <Gantt
              tasks={tasks}
              startDateRange={new Date("2025-02-01T00:00:00")}
              endDateRange={new Date("2027-01-30T00:00:00")}
              listCellWidth={isChecked ? "175px" : ""}
              columnWidth={columnWidth}
              viewMode={ViewMode.Month}
              barBackgroundColor="#6A40D5"
              rowHeight={40}
              fontSize={16}
              fontColor="#101828"
              fontWeight={500}
              headerStyle={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#444",
              }}
              TaskListHeader={({ headerHeight }) => (
                <div
                  style={{
                    height: headerHeight,
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "end",
                    borderTop: "1px solid #ddd",
                    borderBottom: "1px solid #ddd",
                    borderLeft: "1px solid #ddd",
                    color: "#475467",
                    // background: "#f5f5f5",
                    padding: "10px 0",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      paddingLeft: 10,
                      color: "#475467",
                      fontSize: "16px",
                    }}
                  >
                    Process dfdgf
                  </div>
                  <div
                    style={{
                      width: "150px",
                      paddingLeft: 10,
                      ccolor: "#475467",
                      fontSize: "16px",
                    }}
                  >
                    From
                  </div>
                  <div
                    style={{
                      width: "150px",
                      paddingLeft: 10,
                      color: "#475467",
                      fontSize: "16px",
                    }}
                  >
                    To
                  </div>
                </div>
              )}
              TaskListTable={({ rowHeight }) => (
                <div>
                  {tasks.length !== 0 &&
                    tasks.map((task, index) => (
                      <div
                        key={task.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: isEdit ? "1.5px" : "9px",
                          borderBottom: "1px solid #ddd",
                          borderLeft: "1px solid #ddd",
                          backgroundColor:
                            index % 2 === 0 ? "white" : "#f5f5f5",
                        }}
                      >
                        <div style={{ width: "200px", paddingLeft: "10px" }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#101828",
                            }}
                          >
                            {task.name}
                          </Typography>
                        </div>
                        <div style={{ width: "150px" }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#101828",
                            }}
                          >
                            {format(task.start, "MMM.dd.yyyy")}
                          </Typography>
                        </div>
                        <div style={{ width: "150px" }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#101828",
                            }}
                          >
                            {format(task.end, "MMM.dd.yyyy")}
                          </Typography>
                        </div>

                        <IconButton
                          onClick={() => handleOpenModal(task)}
                          // sx={{ padding: "5.5px" }}
                        >
                          {isEdit ? <BoxEditIco /> : null}
                        </IconButton>
                        <IconButton
                          onClick={() => handleDelete(task.id)}
                          // sx={{ padding: "5.5px" }}
                        >
                          {isEdit ? <DeleteIco /> : null}
                        </IconButton>
                      </div>
                    ))}
                </div>
              )}
              barChildren={(task) => (
                <>
                  {tasks.length !== 0 && (
                    <text
                      x={task.x + task.width / 4}
                      y={task.y + task.height / 2}
                      fill="#FFF"
                      fontSize="16"
                      textAnchor="middle"
                      alignmentBaseline="middle"
                    >
                      {/* {task.displayName} */}
                      {task.displayName} ({task.displayStart} -{" "}
                      {task.displayEnd})
                    </text>
                  )}
                </>
              )}
            />
          )}
        </Grid2>

        <Grid2 item size={{ xs: 12 }}>
          <CommonTextField
            border={"0.5px solid #EAECF0"}
            padding={15}
            placeholder={"Ask Haley anything"}
            bgColor={"#F7F8F9"}
            startIcon={
              <InputAdornment position="start">
                <img src={Haley} />
              </InputAdornment>
            }
            endComponent={
              <CommonButton
                // onClick={() => setAi(!ai)}
                fontWeight={600}
                padding={"8px 25px"}
                value={"Ask Haley"}
                endIcon={<AutoAwesome />}
              />
            }
          />
        </Grid2>
      </Grid2>

      <AddEditMilestone
        openDialog={isModalOpen}
        handleCloseDialog={handleCloseModal}
        handleInputChange={handleInputChange}
        newTask={newTask}
        handleAddTask={handleAddTask}
        isEdited={isEdited}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </div>
  );
};

export default ProposalGanttChart;
